import React from 'react'
import { createRoot } from 'react-dom/client'

import { TestApp } from './app/TestApp'
import { startCoreFontLoad } from './app/coreFonts'
import { I18nProvider } from './app/i18n/i18n'
import { ThemeProvider, ensureGlobalStyle } from './app/theme'

function ConsoleTest() {
	// console.log(md5('abc'))
	// console.log('Complicated')
	// console.log(Parser.parse(nmnExamples.structure_complicated))
	// console.log('Multisection')
	// console.log(Parser.parse(nmnExamples.strcture_multiSection))
	// console.log('Multipart')
	// console.log(Parser.parse(nmnExamples.basics_multiPart))
	// console.log('Fracs')
	// console.log(Frac.repr(Frac.create(3, 2)))
	// console.log(Frac.repr(Frac.__sum(Frac.create(1, 2), Frac.create(1, 6), Frac.create(1, 3))))
	// console.log(Frac.repr(Frac.prod(Frac.create(1, 2), Frac.create(2, 3), Frac.create(3, 4))))
	// console.log('Abs Names')
	// console.log(MusicTheory.absName2Pitch('C4'))
	// console.log(MusicTheory.absName2Pitch('C5'))
	// console.log(MusicTheory.absName2Pitch('C3'))
	// console.log(MusicTheory.absName2Pitch('##C4'))
	// console.log(MusicTheory.absName2Pitch('#B4'))
	// console.log(MusicTheory.absName2Pitch('C13'))
	// console.log('Degrees')
	// console.log(MusicTheory.pitchInterval2dKey(1, 'th'))
	// console.log(MusicTheory.pitchInterval2dKey(1, 'thd'))
	// console.log(MusicTheory.pitchInterval2dKey(1, 'thm'))
	// console.log(MusicTheory.pitchInterval2dKey(4, 'thm'))
	// console.log(MusicTheory.pitchInterval2dKey(5, 'thm'))
	// console.log(MusicTheory.pitchInterval2dKey(8, 'th'))
	// console.log(MusicTheory.pitchInterval2dKey(-8, 'th'))
	// return <></>
}

function App() {
	return <>
		{/* 此处的印刷样式需要与 @sparks-notation/static-resources/printing-wrapper/template.html 保持一致 */}
		<style>{`
			@page {
				margin-left: 0cm;
				margin-right: 0cm;
				margin-top: 8.0vw;
				margin-bottom: 8.0vw;
			}
			html, body {
				padding: 0;
				margin: 0;
			}
		`}</style>
		<TestApp />
	</>
}

// 主题变量要在首帧前就位 —— 这里显式调用，不依赖 import 的副作用被保留
ensureGlobalStyle()

// 乐谱字体也在这里**起跑**，但从这里开始就**不等它**了。
//
// 以前 `createRoot(...).render(...)` 是写在 `requestFontLoad` 的回调里的，于是
// 「不画谱的页面也得先下完 31MB 才出东西」——打开一篇纯文字的指南也要付这个代价，
// 字体要是加载不出来更是整站白屏。现在改成：立刻挂载，谁真要用谁自己等
// （`CoreFontSplash` / `NmnLive` 的 `useCoreFontsReady`），由 `TestApp` 的白名单分流。
startCoreFontLoad()

createRoot(document.getElementById('root')!).render(
	<I18nProvider languageKey='zh_cn'>
		<ThemeProvider>
			<App />
		</ThemeProvider>
	</I18nProvider>
)
